import React from 'react';

const DottedLine = props => (
  <svg xmlns="http://www.w3.org/2000/svg" width="40" height="2" viewBox="0 0 40 2">
    <line
      id="Line_29"
      x1="42.5"
      transform="translate(0 1.5)"
      fill="none"
      stroke={props.stroke}
      strokeWidth="2"
      strokeDasharray="1 4"
    />
  </svg>
);
export default DottedLine;



// WEBPACK FOOTER //
// ./src/img/ComponentAsImage/DottedLine.js